import { render, staticRenderFns } from "./registeredSuccess.vue?vue&type=template&id=31ef1534&scoped=true&"
import script from "./registeredSuccess.vue?vue&type=script&lang=js&"
export * from "./registeredSuccess.vue?vue&type=script&lang=js&"
import style0 from "./registeredSuccess.vue?vue&type=style&index=0&id=31ef1534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ef1534",
  null
  
)

export default component.exports